import { DateTime } from 'luxon'

import request from '../Functions/ajax/request'

export default async function ClientLoader ({ params })
{
	return { page: getPage({ params }) };
}

async function getPage ({ params })
{
	if (!params.client_id) throw { code: 404, throw_up:true };

	try
	{
		var { client } = await request('/clients/get-client')
		.config({ })
		.post({ id: params.client_id });
	}
	catch (e)
	{
		console.error(e);
	}

	if (client)
	{
		try
		{
			var { contacts } = await request('/contacts/get-contacts-by-client')
			.config({ })
			.post({ code_client: client.code_client });

		}
		catch (e)
		{
			console.error(e);
		}
	}

	return { client, contacts: contacts || [], time: DateTime.now().toISO() };
}